import React from 'react'
import { TABLE_HEADERS } from '../../shared/types'
import { ISafetyTeamRecord, IMinimalPerson, ISafetyTeamDocument } from '../../shared/types'

import classNames from 'classnames'
import { CircularProgress } from '@mui/material'

import styles from '../../SafetyTeam.module.scss'
import ActiveSafetyTeamRow from './ActiveSafetyTeamRow'

interface IActiveSafetyTeamTableProps {
  records: ISafetyTeamRecord[]
  onSave: (recordId: string) => void
  onEdit: (recordId: string) => void
  onDelete: (recordId: string) => void
  onFieldChange: (
    recordId: string,
    field: keyof ISafetyTeamRecord,
    value: string
  ) => void
  onDriverSelect: (recordId: string, person: IMinimalPerson) => void
  onDocumentChange: (recordId: string, documents: ISafetyTeamDocument[]) => void
  availablePeople: IMinimalPerson[]
  isTableHidden: boolean
  isLoading: boolean
}

const ActiveSafetyTeamTable = ({
  records,
  onSave,
  onEdit,
  onDelete,
  onFieldChange,
  onDriverSelect,
  onDocumentChange,
  availablePeople,
  isTableHidden,
  isLoading,
}: IActiveSafetyTeamTableProps) => {
  return (
    <div
      className={classNames({
        [styles.hidden]: isTableHidden,
        [styles.activeTable]: !isTableHidden,
      })}
    >
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {TABLE_HEADERS.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {records.map((record) => {
              return (
                <ActiveSafetyTeamRow
                  key={record.id}
                  record={record}
                  onSave={onSave}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  onFieldChange={onFieldChange}
                  onDriverSelect={onDriverSelect}
                  onDocumentChange={onDocumentChange}
                  availablePeople={availablePeople}
                />
              );
            })}

            {records.length === 0 && (
              <tr>
                <td colSpan={TABLE_HEADERS.length} className={styles.noData}>
                  {isLoading ? (
                    <CircularProgress color="inherit" />
                  ) : (
                    'No active safety team records. Click "Add new" to create one.'
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ActiveSafetyTeamTable
